
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Model.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

import { Model, ModelProperty } from 'models/Model';


export class QuestionnaireDtoModel extends Model<QuestionnaireDtoModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'name', type: 'string', languageString: 'questionnaireDto.property.name' }
	];
	[key: string]: any;
	
	public name: string;
    
	constructor(){
		super();
		this.name = '';
		
	}
	getProperties(){
		return QuestionnaireDtoModel.classProperties;
	}
}

